import { TerminalClosure } from "@towersystems/roam-common/lib/generated-types";
import { FlatList } from "react-native";
import { Divider } from "@towersystems/roam-common-native";
import { ShiftListItem } from "../ShiftListItem";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ShiftRootParamList } from "../../../../types";
import { DEFAULT_PAGE_WIDTH } from "@towersystems/roam-common-native";
import { Spacings } from "react-native-ui-lib";

export interface ShiftListProps {
  items: TerminalClosure[];
  onEndReached?: () => void;
}
export const ShiftList = ({ items, onEndReached }: ShiftListProps) => {
  const navigation = useNavigation<NavigationProp<ShiftRootParamList>>();

  const renderItem = ({ item }: { item: TerminalClosure }) => {
    return (
      <ShiftListItem
        item={item}
        onPress={() =>
          navigation.navigate("ClosedShiftSummaryScreen", { shiftId: item.id })
        }
      />
    );
  };

  return (
    <FlatList
      data={items}
      style={{}}
      contentContainerStyle={{
        maxWidth: DEFAULT_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center",
        paddingHorizontal: Spacings.s5,
        paddingTop: Spacings.s5,
        paddingBottom: Spacings.s5,
      }}
      renderItem={renderItem}
      ItemSeparatorComponent={Divider}
      scrollEnabled={true}
      onEndReachedThreshold={0.3}
      onEndReached={() => {
        items.length >= 1 && onEndReached && onEndReached();
      }}
    />
  );
};
